{
  "version": 1,
  "asset_id": "fffbb49e-8051-468f-a47a-e256f813b7a5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/fffbb49e-8051-468f-a47a-e256f813b7a5/sleeve-hiatal-type-1-1141.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/fffbb49e-8051-468f-a47a-e256f813b7a5/sleeve-hiatal-type-1-1141.webp",
  "original_filename": "sleeve-hiatal-type-1-1141.webp",
  "size": 114256,
  "content_type": "image/webp",
  "created_at": "2026-09-26T21:30:24Z"
}
